import { useEffect, useState } from "react";
import { publicPricing, pricingQuote } from "../../api/billing";

// Live pricing quote for a given employee/branch count (public calculator).
export const usePricingCalc = () => {
  const [config, setConfig] = useState(null);
  const [input, setInput] = useState({ employees: 25, branches: 3 });
  const [quotes, setQuotes] = useState({ month: null, year: null });

  useEffect(() => {
    publicPricing().then(setConfig);
  }, []);

  useEffect(() => {
    const employees = Math.max(1, Number(input.employees) || 1);
    const branches = Math.max(1, Number(input.branches) || 1);
    Promise.all([
      pricingQuote(employees, "month", branches),
      pricingQuote(employees, "year", branches),
    ]).then(([month, year]) => setQuotes({ month, year }));
  }, [input]);

  return { config, input, setInput, quotes };
};
